import React from "react";
import { Input } from "semantic-ui-react";

interface Props {
  value: string
  onChange: (v: string) => void
}

const City = (props: Props) => {
  return <Input
    icon={"search"}
    fluid
    placeholder={RESX.Address.City}
    value={props.value}
    onChange={e => { props.onChange(e.currentTarget.value); }}
  />;
};

export default City;